/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];

export const SortDirection = {
  Ascending: 0,
  Descending: 1,
} as const;
